import SectionHeader from '../components/SectionHeader';
import { testimonials } from '../data/content';

function Review() {
  return (
    <section className="content-section page-section">
      <SectionHeader label="Review" title="Client testimonials" />
      <div className="testimonial-grid review-grid">
        {testimonials.map((item) => (
          <div key={item.author} className="testimonial-card">
            <p>“{item.quote}”</p>
            <strong>{item.author}</strong>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Review;
